export type GifProvider = 'klipy';

export const PROVIDER_CONFIG: Record<GifProvider, { name: string; url: string }> = {
	klipy: { name: 'KLIPY', url: 'https://klipy.com' },
};

export const detectProviderFromUrl = (url?: string): GifProvider | null => {
	if (!url) return null;
	if (url.includes('klipy.com')) return 'klipy';
	return null;
};
